import { decodeHtmlEntities } from "@repo/shared-utils/common-utils";
import { FC } from "react";
import { twMerge } from "tailwind-merge";
import { IDisclaimerContent } from "../../interfaces/Disclaimer.interface";
interface DisclaimerProps {
  content: IDisclaimerContent;
}
const Disclaimer: FC<DisclaimerProps> = ({ content }) => {
  const { colorSelection, description, heading ,customClass, contentCustomClass} = content;
  return (
    <section className={twMerge("mb-6", customClass)} data-testid="adp-separator">
      <div className={twMerge("p-3", contentCustomClass)} style={{ backgroundColor: colorSelection }}>
        <h2 className="mb-1 text-sm font-medium leading-[22px] text-black md:text-lg">
          {heading}
        </h2>
        <div
          className={`disclaimer-info__desc text-xs leading-[17px] text-gray-600 md:text-sm [&_a]:text-[rgb(255,103,0)] [&_a]:no-underline`}
          dangerouslySetInnerHTML={{ __html: decodeHtmlEntities(description) }}
        ></div>
      </div>
    </section>
  );
};

export default Disclaimer;
